import { Resource } from '__types__/index';
import { ResourceEffect } from './resource.effect.types';

export const resourceEffectReducer = (
  state: Resource,
  action: ResourceEffect
): Resource => {
  if (action.type === 'update') {
    return {
      ...state,
      ...action.payload
    };
  }
  return state;
};
